/* Judge.me v3の描画・フィルターを維持し、公開レビューのGETだけを短期保存する。 */
(() => {
  const I18N = (() => { try { return JSON.parse(document.querySelector('[data-mce-i18n="review"]').textContent); } catch (e) { return {}; } })();
  if (!document.body.classList.contains('mce-page-lp')) return;
  const selector = '#judgeme_product_reviews.jdgm-review-widget';
  const cache = new Map();
  const warming = new Map();
  const ttl = 120000;
  let widget, $, jdgm, active, observer, timer, retries = 0, installed = false;
  let pageTurn, pageTurnTimer;
  let heldBody, heldMinHeight, heightTimer;
  const releaseHeight = () => {
    clearTimeout(heightTimer);
    window.removeEventListener('scrollend', releaseHeight);
    if (heldBody) heldBody.style.minHeight = heldMinHeight;
    heldBody = null;
  };
  const endPageTurn = (release = true) => {
    pageTurn = null; clearTimeout(pageTurnTimer);
    if (release) releaseHeight();
  };

  const keyFor = options => {
    if (!widget?.isConnected || !/^(GET|HEAD)$/i.test(options.type || 'GET')) return null;
    try {
      const url = new URL(options.url, location.href);
      if (!['api.judge.me', 'cdn.judge.me'].includes(url.hostname) ||
          url.pathname !== '/reviews/reviews_for_widget') return null;
      const params = new URLSearchParams(url.search);
      new URLSearchParams(typeof options.data === 'string' ? options.data : $.param(options.data || {}))
        .forEach((value, name) => params.append(name, value));
      if (params.get('product_id') !== widget.dataset.id) return null;
      params.sort();
      return url.origin + url.pathname + '?' + params.toString();
    } catch (_) { return null; }
  };
  const read = key => {
    const entry = cache.get(key);
    if (!entry) return null;
    if (Date.now() - entry.at >= ttl) { cache.delete(key); return null; }
    return entry.value;
  };
  const remember = (key, value) => {
    if (!key || !value || typeof value.html !== 'string') return;
    cache.delete(key);
    cache.set(key, { at: Date.now(), value });
    while (cache.size > 12) cache.delete(cache.keys().next().value);
  };
  const busy = value => {
    widget?.classList.toggle('mce-reviews-busy', value);
    widget?.querySelector('.jdgm-rev-widg__body')?.setAttribute('aria-busy', String(value));
  };
  const errorStatus = message => {
    let status = widget.querySelector('.mce-reviews-status');
    if (!status && !message) return;
    if (!status) {
      status = document.createElement('p');
      status.className = 'mce-reviews-status';
      status.setAttribute('role', 'status');
      widget.append(status);
    }
    status.textContent = message;
    status.hidden = !message;
  };
  const canWarm = () => {
    if (!widget?.isConnected || document.hidden || active || navigator.connection?.saveData ||
        /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return false;
    const rect = widget.getBoundingClientRect();
    return rect.top < innerHeight + 500 && rect.bottom > -100;
  };
  const warm = () => {
    if (!canWarm() || warming.size) return;
    const $widget = $(widget);
    const pagination = widget.querySelector('.jdgm-rev-widg__body .jdgm-paginate');
    if (!pagination || jdgm.isWidgetLoadMore?.() ||
        widget.querySelector('.jdgm-rev-widg__primary-lang')) return;
    const current = Number(pagination.querySelector('[aria-current="page"], .jdgm-curt')?.dataset.page);
    const next = Number(pagination.querySelector('.jdgm-paginate__next-page')?.dataset.page);
    if (!current) return;
    // 初期ページもAPI応答で保存。加工済みDOMの保存による写真機能の欠落を避ける。
    const params = jdgm.ajaxParamsFor($widget);
    const url = jdgm.toCdnUrl($(pagination).data('url'));
    const pages = [current, next].filter(page => page > 0);
    for (const page of pages) {
      const options = { url, type: 'GET', data: { ...jdgm.shopParams(), ...params, page },
        dataType: 'json', timeout: 8000, global: false, mceReviewWarm: true };
      const key = keyFor(options);
      if (!key || read(key)) continue;
      const request = $.ajax(options);
      warming.set(key, request);
      request.always(() => { warming.delete(key); });
      // 次の1ページだけ。失敗時は繰り返さず、実クリック時の標準通信へ戻す。
      request.done(() => schedule());
      break;
    }
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(warm, 180); };

  const install = () => {
    jdgm = window.jdgm;
    $ = jdgm?.$;
    widget = document.querySelector(selector);
    if (!widget || !$?.ajaxPrefilter || !$?.ajaxTransport || !jdgm.ajaxParamsFor ||
        !jdgm.toCdnUrl || !jdgm.shopParams || !jdgm.setupPaginate) return false;
    if (!installed) {
      installed = true;
      // 改ページの開始/完了スクロールとfocusによるジャンプを、一度の移動へまとめる。
      const originalScroll = jdgm.scrollTo;
      const originalFocus = jdgm._focusFirstPaginatedItem;
      if (typeof originalScroll === 'function' && typeof originalFocus === 'function') {
        document.addEventListener('click', event => {
          const link = event.target.closest?.('.jdgm-paginate__page');
          if (!link || !widget?.contains(link) || link.matches('.jdgm-curt, [aria-current="page"]')) return;
          endPageTurn();
          pageTurn = widget;
          // 次ページが短くても、移動前にページ全体が縮んで画面が跳ばないようにする。
          heldBody = widget.querySelector('.jdgm-rev-widg__body');
          if (heldBody) {
            heldMinHeight = heldBody.style.minHeight;
            heldBody.style.minHeight = heldBody.getBoundingClientRect().height + 'px';
          }
          pageTurnTimer = setTimeout(endPageTurn, 16000);
        }, true);
        jdgm.scrollTo = function(target, ...args) {
          if (pageTurn && target?.[0] && pageTurn.contains(target[0])) return;
          const element = target?.[0];
          const sheetBody = element?.closest?.('#mce-review-sheet[open]')?.querySelector('[data-mce-sheet-body]');
          if (sheetBody && sheetBody.contains(element)) {
            // 並べ替え・もっと見る・投稿フォームも背景ページをスクロールさせない。
            sheetBody.scrollTo({
              top: Math.max(0, sheetBody.scrollTop + element.getBoundingClientRect().top - sheetBody.getBoundingClientRect().top),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
            return;
          }
          return originalScroll.call(this, target, ...args);
        };
        jdgm._focusFirstPaginatedItem = function(target) {
          if (!pageTurn || !target?.[0] || !pageTurn.contains(target[0])) return originalFocus.call(this, target);
          const first = pageTurn.querySelector('.jdgm-rev');
          const sheetBody = pageTurn.closest('#mce-review-sheet[open]')?.querySelector('[data-mce-sheet-body]');
          endPageTurn(false);
          if (first) {
            first.setAttribute('tabindex', '-1');
            first.focus({ preventScroll: true });
          }
          // シート内の改ページは背景を動かさず、レビュー画面の先頭へ戻す。
          if (sheetBody) {
            sheetBody.scrollTo({ top: 0, behavior: 'instant' });
            releaseHeight();
            return;
          }
          if (!first) { releaseHeight(); return; }
          const bar = document.querySelector('[data-mce-sticky-buy]');
          const inset = bar && !bar.inert ? Math.max(16, bar.getBoundingClientRect().bottom + 16) : 16;
          window.scrollTo({
            top: Math.max(0, window.scrollY + first.getBoundingClientRect().top - inset),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
          window.addEventListener('scrollend', releaseHeight, { once: true });
          heightTimer = setTimeout(releaseHeight, 1200);
        };
      }
      $.ajaxTransport('+*', options => {
        if (options.mceReviewWarm) return;
        const key = keyFor(options);
        const value = key && read(key);
        if (!value) return;
        options.mceReviewHit = true;
        let cancelled = false;
        return {
          send(_headers, complete) {
            queueMicrotask(() => {
              if (!cancelled) complete(200, 'success', { json: { ...value } }, 'Content-Type: application/json\r\n');
            });
          },
          abort() { cancelled = true; }
        };
      });
      $.ajaxPrefilter((options, original, request) => {
        const key = keyFor(options);
        if (!key) return;
        if (!options.mceReviewWarm) {
          // 未完了の先読みは中止し、ユーザー操作の通信を優先する。
          warming.get(key)?.abort();
          active?.abort();
          active = request;
          busy(true);
          errorStatus('');
          options.timeout = options.timeout || 15000;
          request.fail((_xhr, status) => {
            if (active !== request || status === 'abort') return;
            endPageTurn();
            errorStatus(I18N.load_error || '');
            $(widget).find('.jdgm-rev-widg__paginate-spinner-wrapper').hide();
          });
          request.always(() => {
            if (active !== request) return;
            active = null;
            busy(false);
          });
        }
        request.done(value => {
          if (!options.mceReviewHit) remember(key, value);
          if (!options.mceReviewWarm) schedule();
        });
      });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
      window.addEventListener('pageshow', () => { cache.clear(); schedule(); });
      document.addEventListener('submit', event => {
        if (!event.target.closest(selector)) return;
        cache.clear();
        warming.forEach(request => request.abort());
        warming.clear();
      }, true);
    }
    widget.classList.add('mce-reviews-cached');
    observer?.disconnect();
    observer = new IntersectionObserver(schedule, { rootMargin: '500px 0px' });
    observer.observe(widget);
    schedule();
    return true;
  };
  const start = () => {
    if (install() || ++retries >= 120) return;
    setTimeout(start, 250);
  };
  document.addEventListener('shopify:section:load', () => { retries = 0; start(); });
  document.addEventListener('shopify:section:unload', event => {
    if (!widget || !event.target.contains(widget)) return;
    endPageTurn();
    active?.abort();
    warming.forEach(request => request.abort());
    warming.clear(); cache.clear(); observer?.disconnect(); clearTimeout(timer);
  });
  start();
})();
